








































import { Vue, Component } from 'vue-property-decorator';
import XGplayer from '../components/XGplayer.vue';
import VoteButton from '../components/VoteButtonNew.vue';
import vueCanvasPoster from 'vue-canvas-poster';
import { isWeiXin } from '@/common/ts/common';
import { Icon, Swipe, SwipeItem, Lazyload, ImagePreview } from 'vant';
import { detail } from '../api';
import QRCode from 'qrcode';
Vue.use(Swipe)
  .use(SwipeItem)
  .use(Lazyload)
  .use(vueCanvasPoster)
  .use(Icon);
@Component({
  components: {
    XGplayer,
    VoteButton,
  },
})
export default class Detail extends Vue {
  img: any = [
    'https://img01.yzcdn.cn/vant/apple-1.jpg',
    'https://img01.yzcdn.cn/vant/apple-1.jpg',
  ];
  obj: any = {};
  title: string = '';
  canvasConfig: any = null;
  posterUrl = '';
  showModal = false;
  qrUrl = '';
  get query() {
    return this.$route.query;
  }
  get voteName() {
    return '2023project/q3/2023sdjhc';
  }
  success(src: any) {
    // 设置img的src
    this.posterUrl = src;
    this.toggleModal();
  }
  toggleModal() {
    this.showModal = !this.showModal;
  }
  // 海报分享相关
  genQrCode() {
    const targetUrl = `${location.origin}${process.env.VUE_APP_PUBLIC_PATH}WLJP0411/activity`;
    QRCode.toDataURL(
      targetUrl,
      {
        quality: 1,
        margin: 0,
        scale: 20,
      },
      (err: any, url: string) => {
        if (err) {
          console.log('err occur:', err);
        } else {
          this.qrUrl = url;
        }
      },
    );
  }
  genCanvas(obj: any) {
    this.genQrCode();
    // 开始绘制
    this.canvasConfig = {
      width: '675px',
      height: '1080px',
      background: '#fff',
      borderRadius: '20px',
      views: [
        {
          type: 'image',
          id: 'cover',
          url: require('../assets/banner.jpg'),
          css: {
            top: 0,
            left: 0,
            width: '675px',
            height: '333px',
          },
        },
        {
          type: 'text',
          id: 'b',
          text: obj.name,
          css: {
            top: ['90px', 'cover'],
            left: '337px',
            color: '#666',
            fontSize: '32px',
            align: 'center',
          },
        },
        {
          type: 'text',
          id: 'b',
          text: obj.name,
          css: {
            top: ['90px', 'cover'],
            left: '337px',
            color: '#666',
            fontSize: '32px',
            align: 'center',
          },
        },
        {
          type: 'text',
          id: 'd',
          text: `我正在参加首届“泉声心·全国温泉歌手大赛”，邀你为我点赞！`,
          css: {
            top: ['300px', 'cover'],
            width: '615px',
            left: '30px',
            color: '#333',
            fontSize: '32px',
            lineHeight: '50px',
            maxLines: 4,
          },
        },
        {
          type: 'image',
          url: this.qrUrl,
          id: 'qr',
          css: {
            bottom: '100px',
            left: '337px',
            width: '160px',
            height: '160px',
            mode: 'aspectFill',
            align: 'center',
          },
        },
        {
          type: 'text',
          id: 'e',
          text: '长按图片保存海报',
          css: {
            bottom: '50px',
            left: '337px',
            color: '#666',
            fontSize: '28px',
            align: 'center',
          },
        },
      ],
    };
  }
  async mounted() {
    const res: any = await detail(this.query.id);
    this.obj = res.data;
    const content = '2023大渡口十大江湖菜评选活动·' + this.obj.title;
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/d/file/image/default/2023-09-25/5beadd06122151bed62fde38c29fbf6a.jpeg';
    // App分享
    this.$appShareInfo({
      title: content,
      url: location.href,
      subtitle: ``,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: content,
        subtitle: ``,
        image: cover,
      });
    }
  }
  previe(imageList: any, index: number) {
    const scroll =
      document.documentElement.scrollTop || document.body.scrollTop;
    ImagePreview({
      images: imageList, // 预览图片的那个数组
      showIndex: true,
      loop: false,
      startPosition: index, // 指明预览第几张图
      onClose() {
        document.documentElement.scrollTop = scroll;
        document.body.scrollTop = scroll;
      },
    });
  }

  votSuccess(data: any, index: number) {
    this.obj.votes = data;
  }
}
